<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row>
        <el-form-item
          :label="$l('form_label_orderFileType') || '订单文件类型'"
          prop="orderFileType"
        >
          <dict-select
            v-model="formData.orderFileType"
            url="/sys/common/dict/system"
            :body="orderFileTypeParams"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            size="mini"
            clearable
            filterable
          ></dict-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item :label="$l('form_label_fileRemark') || '备注说明'">
          <el-input
            v-model="formData.remark"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            :maxlength="500"
            show-word-limit
            clearable
            type="textarea"
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <el-upload
      drag
      action="#"
      multiple
      :file-list="listFile"
      :auto-upload="false"
      :on-change="onFileChange"
      :on-remove="onFileChange"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
        }}<em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
      </div>
    </el-upload>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import { sizeOf } from '@/libs/util'

import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  data() {
    return {
      listFile: [],
      formData: {
        orderFileType: 'order_label',
        remark: '',
      },
      orderFileTypeParams: { dictType: 'orderFileType' },
      rules: {
        orderFileType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onFileChange(files, fileList) {
      this.listFile = fileList
    },
    async validate() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false
      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: '请选择上传附件',
          type: 'warning',
        })
        return false
      }
      return true
    },
    async upload() {
      if (!(await this.validate())) return
      const { orderFileType, remark } = this.formData

      const files = this.listFile.map(({ name: fileName, raw }) => ({
        orderFileType,
        fileName,
        raw,
        remark,
      }))

      const uploadTask = files.map((file) => {
        return new Promise((resolve) => {
          this.$api
            .SYS_UPLOAD(file.raw)
            .then((res) =>
              resolve({
                fileCode: res.body.fileId,
                fileUrl: res.body.url,
                fileName: file.fileName,
                fileSize: file.raw.size ? sizeOf(file.raw.size) : 0,
                orderFileType: file.orderFileType,
                remark: file.remark,
              })
            )
            .catch(() => resolve(null))
        })
      })
      return await Promise.all(uploadTask)
    },
  },
}
</script>
